import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    quote: 'This platform helped me fill my pottery workshop AND gain 500+ Instagram followers. Absolute game-changer for small creators.',
    author: 'Sarah Mitchell',
    role: 'Pottery Workshop Host',
    followers: 500,
    image: 'https://public.readdy.ai/ai/img_res/87e0936a1fbf86354308abb6e6d8e01c.jpg',
  },
  {
    id: 2,
    quote: 'I launched my tech meetup series here and connected with thousands of engaged followers. The social growth aspect is brilliant!',
    author: 'Marcus Chen',
    role: 'Tech Meetup Organizer',
    followers: 1200,
    image: 'https://readdy.ai/api/search-image?query=male%20tech%20entrepreneur%20presenting%20at%20modern%20conference%20with%20engaged%20audience%2C%20professional%20event%20photography%20with%20blue%20ambient%20lighting%2C%20innovation%20and%20networking%20atmosphere&width=800&height=600&seq=test002&orientation=landscape',
  },
  {
    id: 3,
    quote: 'As a yoga instructor, this platform helped me build a community while filling my classes. The follow-to-register model works perfectly.',
    author: 'Emma Rodriguez',
    role: 'Wellness Retreat Leader',
    followers: 750,
    image: 'https://readdy.ai/api/search-image?query=female%20yoga%20instructor%20leading%20peaceful%20outdoor%20class%20at%20sunrise%2C%20serene%20natural%20setting%20with%20mountains%2C%20wellness%20and%20mindfulness%20photography%20with%20soft%20golden%20light&width=800&height=600&seq=test003&orientation=landscape',
  },
  {
    id: 4,
    quote: 'My music events sell out faster now, and I gained authentic followers who actually engage with my content. Win-win!',
    author: 'DJ Alex Rivera',
    role: 'Music Event Producer',
    followers: 2100,
    image: 'https://readdy.ai/api/search-image?query=DJ%20performing%20at%20vibrant%20nightclub%20with%20colorful%20lights%20and%20energetic%20crowd%2C%20professional%20concert%20photography%20with%20dynamic%20atmosphere%20and%20neon%20lighting%20effects&width=800&height=600&seq=test004&orientation=landscape',
  },
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-5 gap-8 sm:gap-12 items-center">
          <div className="lg:col-span-2 space-y-6 sm:space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full">
              <span className="text-xs sm:text-sm font-semibold">Creator Stories</span>
            </div>

            <div className="relative">
              <i className="ri-double-quotes-l text-4xl sm:text-6xl text-purple-200 absolute -top-2 sm:-top-4 -left-1 sm:-left-2"></i>
              <p className="text-xl sm:text-2xl md:text-3xl font-serif italic text-gray-800 leading-relaxed pl-6 sm:pl-8">
                {testimonials[activeIndex].quote}
              </p>
            </div>

            <div className="space-y-2">
              <h4 className="text-lg sm:text-xl font-bold text-gray-900">{testimonials[activeIndex].author}</h4>
              <p className="text-xs sm:text-sm text-gray-600">{testimonials[activeIndex].role}</p>
              <div className="flex items-center gap-2 pt-2">
                <i className="ri-instagram-line text-pink-500"></i>
                <span className="text-xs sm:text-sm font-semibold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                  +{testimonials[activeIndex].followers} followers gained
                </span>
              </div>
            </div>

            <div className="flex items-center gap-2 pt-4">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all ${
                    index === activeIndex
                      ? 'w-8 bg-gradient-to-r from-purple-600 to-pink-600'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                  aria-label={`View testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="lg:col-span-3 relative order-first lg:order-last">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={testimonials[activeIndex].image}
                alt={testimonials[activeIndex].author}
                className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover object-top"
              />
              <div className="absolute inset-y-0 left-0 w-20 sm:w-32 bg-gradient-to-r from-white to-transparent lg:block hidden"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
